import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { crudSaga, querySaga } from '../../../utils/reduxHelper';

function* resetStoreSysIdSaga() {
    yield put(appActions.STORESYSID_RESET_SUCCESS());
}

function* watchStoreSysIdUpdateRequest() {
    yield takeLatest(
        appActions.STORESYSID_UPDATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/store/system-id',
                appActions.STORESYSID_UPDATE_SUCCESS,
                appActions.STORESYSID_UPDATE_FAILURE,
                'PUT',
            );
        },
    );
}

function* watchStoreSysIdCreateRequest() {
    yield takeLatest(
        appActions.STORESYSID_CREATE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/store/system-id',
                appActions.STORESYSID_CREATE_SUCCESS,
                appActions.STORESYSID_CREATE_FAILURE,
                'POST',
            );
        },
    );
}

function* watchStoreSysIdDeleteRequest() {
    yield takeLatest(
        appActions.STORESYSID_DELETE_REQUEST.type,
        function* (action) {
            yield* crudSaga(
                action,
                '/store/system-id',
                appActions.STORESYSID_DELETE_SUCCESS,
                appActions.STORESYSID_DELETE_FAILURE,
                'DELETE',
            );
        },
    );
}

function* watchStoreSysIdGetAllRequest() {
    yield takeLatest(
        appActions.STORESYSID_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/store/system-id',
                appActions.STORESYSID_GET_ALL_SUCCESS,
                appActions.STORESYSID_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* storeSysIdWatcher() {
    yield* watchStoreSysIdUpdateRequest();
    yield* watchStoreSysIdCreateRequest();
    yield* watchStoreSysIdGetAllRequest();
    yield* watchStoreSysIdDeleteRequest();
    yield takeLatest(appActions.STORESYSID_RESET_REQUEST.type, resetStoreSysIdSaga);
    // Add other watchers here
}
